// LineChart.js
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp} = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  name: 'LineChart',
  props: ['options'],
  data:{
    chart:null
  },
  mounted () {     
      const me = this      
      this.renderChart(this.chartData, {...this.options ,onClick:function(evt) {
            me.chart = this.chart
            const elt = this.chart?.getElementAtEvent(evt)?.at(0)
            if(elt) {
              me.$emit('onPointClick',elt._index)              
            } 
          } 
      })   
  }
}